(() => {
  const normalize = (value = '') => String(value)
    .replace(/[₂²]/g, '2')
    .replace(/[₀⁰]/g, '0')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

  const openRequestedPlatform = () => {
    const requested = normalize(new URL(window.location.href).searchParams.get('aw_platform') || '');
    if (!requested) return;

    const root = document.querySelector('[data-aw-compatibility-search]');
    const form = root?.querySelector('[data-aw-manual-form]');
    const platformSelect = form?.querySelector('[data-aw-manual-platform]');
    if (!root || !form || !platformSelect) return;

    const option = [...platformSelect.options].find((item) => normalize(item.value) === requested);
    if (!option) return;

    platformSelect.value = option.value;
    const manufacturer = form.querySelector('[data-aw-manual-manufacturer]');
    const model = form.querySelector('[data-aw-manual-model]');
    const type = form.querySelector('[data-aw-manual-type]');
    if (manufacturer) manufacturer.value = '';
    if (model) model.value = '';
    if (type) type.value = '';

    const launch = () => form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    if (root.dataset.awReady === 'true') launch();
    else window.setTimeout(launch, 0);
  };

  const modelPageMap = () => {
    const map = new Map();
    document.querySelectorAll('[data-aw-tool-model],[data-aw-model-context-model]').forEach((node) => {
      const draftUrl = String(node.dataset.pageDraftUrl || '').trim();
      const handle = String(node.dataset.handle || '').trim();
      if (!draftUrl || !handle) return;
      try {
        map.set(new URL(draftUrl, location.origin).pathname.replace(/\/+$/, ''), {
          handle,
          published: node.dataset.pagePublished === 'true'
        });
      } catch (_) {}
    });
    return map;
  };

  const guardUnpublishedModelLinks = (scope = document) => {
    const pages = modelPageMap();
    if (!pages.size) return 0;
    let changed = 0;
    scope.querySelectorAll?.('a[href*="/pages/compatibilite-airsoft-"]').forEach((link) => {
      let pathname = '';
      try { pathname = new URL(link.href, location.origin).pathname.replace(/\/+$/, ''); }
      catch (_) { return; }
      const model = pages.get(pathname);
      if (!model || model.published) return;
      const target = new URL('/pages/compatibilite-airsoft', location.origin);
      target.searchParams.set('aw_model', model.handle);
      target.searchParams.set('aw_from', 'directory');
      link.href = `${target.pathname}${target.search}`;
      link.dataset.awUnpublishedModelFallback = 'true';
      if (/voir\s+les\s+compatibilit[eé]s/i.test(link.textContent || '')) {
        link.innerHTML = 'Analyser ce modèle <span aria-hidden="true">→</span>';
      }
      changed += 1;
    });
    return changed;
  };

  let guideSourcePromise = null;
  let guidePanel = null;
  let guideLinks = null;
  let guideSignature = '';

  const loadGuideSource = () => {
    if (guideSourcePromise) return guideSourcePromise;
    const url = new URL(window.location.href);
    url.searchParams.set('section_id', 'aw-compatibility-guide-bridge-data');
    guideSourcePromise = fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then((response) => response.ok ? response.text() : '')
      .then((html) => html ? new DOMParser().parseFromString(html, 'text/html') : null)
      .catch(() => null);
    return guideSourcePromise;
  };

  const ensureGuidePanel = () => {
    if (guidePanel?.isConnected) return guidePanel;
    const root = document.querySelector('[data-aw-compatibility-search]');
    if (!root) return null;
    guidePanel = document.createElement('section');
    guidePanel.className = 'aw-compatibility-guides';
    guidePanel.hidden = true;
    guidePanel.setAttribute('aria-label', 'Guides liés au modèle sélectionné');
    guidePanel.innerHTML = '<div class="aw-compatibility-guides__head"><span>GUIDES LIÉS</span><h3>Guides exacts pour ce modèle</h3><p>Articles reliés à ce modèle dans Compatibility AW.</p></div><div class="aw-compatibility-guides__links" role="list"></div>';
    guideLinks = guidePanel.querySelector('.aw-compatibility-guides__links');
    const identity = root.querySelector('[data-aw-compat-identity]');
    const summary = root.querySelector('[data-aw-compat-summary]');
    const catalog = root.querySelector('[data-aw-compat-catalog]');
    const anchor = identity || summary || catalog;
    if (anchor?.parentNode) anchor.insertAdjacentElement('afterend', guidePanel);
    else root.appendChild(guidePanel);

    if (!document.getElementById('aw-compatibility-guides-style')) {
      const style = document.createElement('style');
      style.id = 'aw-compatibility-guides-style';
      style.textContent = '.aw-compatibility-guides{margin:16px 0;padding:18px;border:1px solid rgba(255,255,255,.1);border-radius:12px;background:#0d0d0f}.aw-compatibility-guides__head span{display:block;margin-bottom:6px;color:#ff3b30;font-size:11px;font-weight:800;letter-spacing:.12em}.aw-compatibility-guides__head h3{margin:0 0 6px;color:#fff;font-size:18px}.aw-compatibility-guides__head p{margin:0 0 12px;color:#aaa;font-size:13px}.aw-compatibility-guides__links{display:grid;gap:8px}.aw-compatibility-guides__links a{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:11px 12px;border:1px solid rgba(255,255,255,.12);border-radius:9px;background:#151518;color:#f5f5f5;text-decoration:none;font-weight:700;line-height:1.35}.aw-compatibility-guides__links a:hover{border-color:#ff3b30;color:#fff}.aw-compatibility-guides__links a::after{content:"→";color:#ff3b30;flex:0 0 auto}@media(max-width:749px){.aw-compatibility-guides{padding:15px}.aw-compatibility-guides__links a{align-items:flex-start}}';
      document.head.appendChild(style);
    }
    return guidePanel;
  };

  const hideGuidePanel = () => {
    if (guidePanel) guidePanel.hidden = true;
    guideSignature = '';
  };

  const renderExactGuides = async (detail = {}) => {
    const urlModel = new URL(window.location.href).searchParams.get('aw_model') || '';
    const candidates = [detail.model, detail.modelLabel, urlModel].map(normalize).filter(Boolean);
    if (!candidates.length) { hideGuidePanel(); return 0; }

    const source = await loadGuideSource();
    if (!source) { hideGuidePanel(); return 0; }
    const groups = [...source.querySelectorAll('[data-aw-guide-model]')];
    const group = groups.find((node) => {
      const keys = [node.dataset.modelHandle, node.dataset.modelName, node.dataset.modelReference].map(normalize).filter(Boolean);
      return candidates.some((candidate) => keys.includes(candidate));
    });
    if (!group) { hideGuidePanel(); return 0; }

    const links = [...group.querySelectorAll('[data-aw-guide-link]')].slice(0, 4);
    if (!links.length) { hideGuidePanel(); return 0; }
    const signature = `${group.dataset.modelHandle || ''}|${links.map((link) => link.getAttribute('href') || '').join('|')}`;
    const panel = ensureGuidePanel();
    if (!panel || !guideLinks) return 0;
    if (signature !== guideSignature) {
      guideLinks.innerHTML = '';
      links.forEach((sourceLink) => {
        const link = document.createElement('a');
        link.setAttribute('role', 'listitem');
        link.href = sourceLink.getAttribute('href') || '#';
        link.textContent = sourceLink.textContent.trim();
        link.dataset.awP1Track = 'compatibility_to_guide_exact';
        guideLinks.appendChild(link);
      });
      guideSignature = signature;
      try {
        window.AWAnalytics?.track?.('p1_block_viewed', {
          block: 'compatibility_exact_guides',
          model: group.dataset.modelHandle || '',
          guides_count: links.length
        });
      } catch (_) {}
    }
    panel.hidden = false;
    return links.length;
  };

  const refresh = (scope = document) => {
    openRequestedPlatform();
    guardUnpublishedModelLinks(scope);
    renderExactGuides({ model: new URL(window.location.href).searchParams.get('aw_model') || '' });
  };

  let pending = false;
  const scheduleGuard = (scope = document) => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      guardUnpublishedModelLinks(scope);
    });
  };

  if ('MutationObserver' in window) {
    new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.addedNodes?.length)) scheduleGuard(document);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  window.addEventListener('aw:model-index-ready', () => scheduleGuard(document));
  window.addEventListener('aw:compatibility-changed', (event) => renderExactGuides(event.detail || {}));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => refresh(document), { once: true });
  else refresh(document);
  document.addEventListener('shopify:section:load', (event) => refresh(event.target || document));
  [100, 500, 1500].forEach((delay) => window.setTimeout(() => guardUnpublishedModelLinks(document), delay));

  window.AWCompatibilityPlatformLinks = {
    version: '1.2.0',
    openRequestedPlatform,
    guardUnpublishedModelLinks,
    renderExactGuides,
    policy: 'platform-deeplink;unpublished-model-page-fallback-to-exact-search;exact-model-guide-bridge'
  };
})();
